import React from "react";
import { connect } from 'react-redux';
import SideNav from '../../shared/Sidenav';
import '../../../css/TransactionFees/TransactionFees.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import message from '../../../data/Message.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { TRANSACTIONFEES_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { success } from '../../../redux/_actions/serviceType.actions';
import { store } from '../../../redux/_helpers/store';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
let viewOnly = false;
class TransactionFees extends React.Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            serviceTypeData: [],
            serviceTypeDropdown: false,
            serviceTypeValue: '',
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({
                serviceTypeDropdown: false,
            });
        }
    };
    toggleServiceTypeDropdown = () => {
        this.setState({ serviceTypeDropdown: !this.state.serviceTypeDropdown });
    };
    changeServiceType = (event) => {
        const found = this.state.serviceTypeData.find((serviceType) => {
            if (serviceType.service === event.target.innerText) {
                return serviceType
            }
        })
        this.props.history.push("/ServiceType")
        store.dispatch(success(found.service))
        this.setState({ serviceTypeValue: found.service });
        this.setState({ serviceTypeDropdown: !this.state.serviceTypeDropdown });
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 18) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
            ApiCall(
                'GET',
                serviceBaseURL + TRANSACTIONFEES_ENDPOINT,
                {},
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag !== -1) {
                    if (data.flag === 500) {
                        toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                    }
                    else {
                        console.log('I am 200!');
                        this.setState({serviceTypeData: data})
                    }
                }
                else {
                    //  toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                }
            })
    }
    render() {
        return (
            <div className="outer1"><div className="outer1" id="outerdiv">
                <MetaDecorator title={TitleDescription.transactionFeesPageTitle} description={TitleDescription.transactionFeesPageDescription} />
                <div className="transactionFeesFunctionContainer" >
                    <SideNav />
                    <div id="transactionFeesPart">
                        <div class="transactionFeesHeadingDiv">
                            <h1 id='transactionFeesHeadingTitle'>Transaction Fees</h1>
                            <div class="transectionuprightdiv">
                                <div class="transactionFeesdefaultAmtDropDiv">
                                    <input class="transactionFeesUpSearchInputBox" readOnly placeholder="- - Select Service Type - -" value={this.state.serviceTypeValue} />
                                    <img src={this.state.serviceTypeDropdown ? require('../../../assets/images/arrow-up.svg') : require('../../../assets/images/drpdwnArrow.svg')} onClick={this.toggleServiceTypeDropdown} width="14" height="14" class="d-inline-block ml-2 mt-2" alt="" loading="lazy" />
                                </div>
                                {this.state.serviceTypeDropdown && (
                                    <div class="caaad08raise" >
                                        <div class="caadropdowncardraise" ref={this.container} >
                                            {
                                                (this.state.serviceTypeData.map((Servicetypedata, index) => {
                                                    return (
                                                        <table class='caaad09raise' key={index} onClick={(index1) => this.changeServiceType(index1)} >
                                                            <td class="caatt1raise" >
                                                                <small id="caatt2raise" >{Servicetypedata.service} </small>
                                                            </td>
                                                        </table>
                                                    );
                                                }))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* View Only Access */}
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        {(this.state.serviceTypeValue === "") && <>
                            <div class="transactionFeesBlankDiv">
                                <small class="transectionBlankText">Please select <small class="transectionBlankBoldText">‘Service Type’</small> from the dropdown</small>
                            </div>
                        </>}
                    </div>
                </div>
            </div></div >
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(TransactionFees);